module.exports = __webpack_public_path__ + "img/a-banner3.a7998b58.png";